import { render } from "./modalSearch.vue?vue&type=template&id=7c7e7184&scoped=true"
import script from "./modalSearch.vue?vue&type=script&lang=js"
export * from "./modalSearch.vue?vue&type=script&lang=js"

import "./modalSearch.vue?vue&type=style&index=0&id=7c7e7184&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7e7184"]])

export default __exports__